import { LitElement, html, svg } from 'lit';

export class IconBoatLength24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Båt med piler i begge retninger</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.5 8 18 6.5H1.76a.406.406 0 0 0-.37.576 9.748 9.748 0 0 0 8.856 5.674h11.88V8H19.5ZM1.5 19h21M7 6.5 10.5 2M3.464 17 1.5 19l1.964 2M20.536 17l1.964 2-1.964 2"></path></svg>`; }
}
if (!customElements.get('f-icon-boat-length24', IconBoatLength24)) {
  customElements.define('f-icon-boat-length24', IconBoatLength24);
}